import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, unref as _unref, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "rounded-md shadow-md bg-white overflow-hidden animate-pulse relative"
}
const _hoisted_2 = { class: "min-w-[13rem] w-full min-h-[13rem] aspect-square bg-gray-700" }
const _hoisted_3 = { class: "relative left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2" }
const _hoisted_4 = ["src", "loading"]
const _hoisted_5 = { class: "justify-center items-center flex h-7 rounded-md px-2 py-1" }
const _hoisted_6 = { class: "text-center text-ellipsis whitespace-nowrap overflow-hidden text-white" }
const _hoisted_7 = {
  key: 2,
  class: "rounded-full p-1 bg-black text-yellow-400 w-8 h-8 absolute right-1 top-1"
}
const _hoisted_8 = { class: "absolute top-[7px] left-3" }
const _hoisted_9 = { class: "text-sm text-black" }
const _hoisted_10 = { class: "absolute top-2 right-[11px]" }
const _hoisted_11 = { class: "text-sm text-black" }

import { ref, watch, onBeforeMount, computed } from 'vue';
import { LikeFilled, StarFilled } from '@ant-design/icons-vue';
import { Doujin, DoujinSource } from '@/model/doujin';
import { getImage } from '@/repository/doujin';

const imagePlaceholder =
	'https://www.signfix.com.au/wp-content/uploads/2017/09/placeholder-600x400.png';

export default /*#__PURE__*/_defineComponent({
  __name: 'DoujinCard',
  props: {
    doujin: {},
    imageLoading: {}
  },
  emits: ["click"],
  setup(__props: any, { emit }) {

const props = __props;



onBeforeMount(async () => await fetchImage(props.doujin.imageURL));

const url = ref('');
const isLoading = ref(true);
const imageLoading = computed(() => props.imageLoading ?? 'lazy');



watch(() => props.doujin.imageURL, fetchImage);

async function fetchImage(imageURL: string) {
	if (
		[
			DoujinSource.NHentai,
			DoujinSource.DoujinTH,
			DoujinSource.HentaiThai,
			DoujinSource.Koharu
		].includes(props.doujin.source as DoujinSource)
	) {
		const res = await getImage(imageURL);
		if (res && res.data) {
			url.value = URL.createObjectURL(res.data);
		}
		return;
	}
	url.value = props.doujin.imageURL;
}

return (_ctx: any,_cache: any) => {
  const _component_a_spin = _resolveComponent("a-spin")!

  return (_openBlock(), _createElementBlock("div", {
    class: "hover:brightness-75 ease-in duration-100 rounded-md min-w-[13rem] bg-black relative cursor-pointer",
    onClick: _cache[2] || (_cache[2] = ($event: any) => (emit('click', _ctx.doujin)))
  }, [
    (isLoading.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_component_a_spin, {
                tip: "Loading...",
                size: "large",
                class: "animate-pulse"
              })
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (url.value)
      ? (_openBlock(), _createElementBlock("img", {
          key: 1,
          alt: "",
          src: url.value,
          onLoad: _cache[0] || (_cache[0] = () => (isLoading.value = false)),
          onError: _cache[1] || (_cache[1] = 
				() => {
					isLoading.value = false;
					url.value = imagePlaceholder;
				}
			),
          class: _normalizeClass(
				(isLoading.value
					? 'absolute w-0 h-0 opacity-0'
					: 'min-w-[13rem] min-h-[13rem] w-full aspect-square shadow-md') +
				' object-cover rounded-md '
			),
          loading: imageLoading.value,
          referrerPolicy: "no-referrer"
        }, null, 42, _hoisted_4))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.doujin.title), 1)
    ]),
    (_ctx.doujin.isFavorite || (_ctx.doujin.yourRating && _ctx.doujin.yourRating > 0))
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
          (_ctx.doujin.isFavorite)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createVNode(_unref(StarFilled), { class: "text-2xl" }),
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.doujin.yourRating), 1)
                ])
              ], 64))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _createVNode(_unref(LikeFilled), { class: "text-xl text-blue-300" }),
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.doujin.yourRating), 1)
                ])
              ], 64))
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})